import { IdProvider } from '@scenario/providers/id.provider';

export class IncrementalIdProvider implements IdProvider {
  private idIncrement: number = 0;

  generate(): string {
    this.idIncrement++;
    return this.idIncrement.toString();
  }
}
